import { GetStaticPropsContext, NextPageContext } from 'next'
import { Store } from 'redux'
import { getSingleQuery } from '@ucheba/utils/helpers/router'
import {
  institutionItemSelectors,
  institutionItemThunks,
} from '@ucheba/store/institutions/item'
import {
  institutionsProgramTypesSelectors,
  institutionsProgramTypesThunks,
} from '@ucheba/store/institutions/program-types'
import { EQueryKeysByFacetName } from '@ucheba/store/institutions/programs/types'
import { fetchCurrentPrograms, getProgramType } from '../[id]/programs/[slug]/bll'
import { headerActions } from '../../../components/Header/store'

type GetProgramsPageProps = {
  ctx: NextPageContext | GetStaticPropsContext
  store: Store
}

type GetProgramsPageReturn = Promise<{
  notFound?: boolean
  content?: {
    seo: {
      meta: {
        title: string
        description: string
        keywords: string
      }
    }
  }
}>

export const getProgramsPageProps = async (
  props: GetProgramsPageProps
): Promise<GetProgramsPageReturn> => {
  const { ctx, store } = props
  const params = (ctx as GetStaticPropsContext).params || (ctx as NextPageContext).query
  const { dispatch, getState } = store

  const id = params?.id
  const slug = getSingleQuery(params?.slug)

  if (!getState()?.institutionItem?.currentInstitution?.id) {
    await dispatch<any>(institutionItemThunks.fetchInstitution({ data: { id } }))
  }

  await dispatch<any>(institutionsProgramTypesThunks.fetch({ data: { id } }))

  const institution = institutionItemSelectors.currentInstitution(getState())

  const programTypes = institutionsProgramTypesSelectors.programTypes(getState())

  const programType = getProgramType(slug, programTypes) || programTypes[0]

  if (!institution) {
    return {
      notFound: true,
    }
  }

  const { name, keywords, hasPrograms } = institution

  const paramsObj = (() => {
    if (params) {
      return Object.keys(params).reduce((acc, queryKey) => {
        const key = queryKey.replace('[]', '')

        if (key === EQueryKeysByFacetName.withoutExams) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          acc[EQueryKeysByFacetName.withoutExams] = query[key] && query[key][0]
        } else if (queryKey.includes('[]') && !Array.isArray(params[queryKey])) {
          acc[key] = [params[queryKey]]
        } else {
          acc[key] = params[queryKey]
        }

        return acc
      }, {})
    }

    return {} as any
  })()

  const offset = (() => {
    if (params.page) {
      return Number(params.page) - 1
    }

    return 0
  })()

  if (programType) {
    await fetchCurrentPrograms(
      String(id),
      offset,
      paramsObj,
      programType.value,
      dispatch,
      hasPrograms
    )
  }

  if (!programTypes.length) {
    return {
      notFound: true,
    }
  }

  const programTypeName = (() => {
    switch (programType?.value) {
      case 1002:
        return `${programType.genitiveName} образования`
      case 1001:
        return `${programType.genitiveName} образования`
      default:
        return programType?.genitiveName
    }
  })()

  const title = `Программы ${programTypeName?.toLowerCase() || ''} — ${name} — Учеба.ру`

  dispatch(headerActions.toggleHeader(true))

  return {
    content: {
      seo: {
        meta: {
          title,
          description: `Программы обучения, варианты и условия поступления ${
            programTypeName?.toLowerCase() || ''
          } — ${name}.`,
          keywords,
        },
      },
    },
  }
}
